import { render, staticRenderFns } from "./AiShadowChat.vue?vue&type=template&id=557019d9&scoped=true"
import script from "./AiShadowChat.vue?vue&type=script&lang=js"
export * from "./AiShadowChat.vue?vue&type=script&lang=js"
import style0 from "./AiShadowChat.vue?vue&type=style&index=0&id=557019d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557019d9",
  null
  
)

export default component.exports